import { render } from "./Backlogs.vue?vue&type=template&id=78ba1480&scoped=true"
import script from "./Backlogs.vue?vue&type=script&lang=js"
export * from "./Backlogs.vue?vue&type=script&lang=js"

import "./Backlogs.vue?vue&type=style&index=0&id=78ba1480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ba1480"]])

export default __exports__